/* eslint-disable max-len */
export const ESTIMATE_API_URL = '/product-information/rental/inventory/pricing/estimate';

export const TERMS_CONS_PDF_URL = 'https://assets.homedepot-static.com/online-rental/tool-assets/v4.2.8/pdf/HD-Equipment-Rental-Terms-and-Conditions-11.3.22.pdf#page=2';
export const TERMS_CONS_URL = 'https://www.homedepot.com/c/Tool_Rental_FAQ#:~:text=EQUIPMENT%20DAMAGE%20%2F%20REPAIRS%20%2F%20PROTECTION';
